import React, { FC } from "react";

import { BigLoader, StyledContainer, StyledInnerContainer, StyledTextContainer } from "./styled";

type LoaderWithTextProps = {
    text: string;
};

const LoaderWithText: FC<LoaderWithTextProps> = ({ text }) => {
    return (
        <StyledContainer>
            <StyledInnerContainer role="progressbar" aria-busy="true">
                <BigLoader className="loading-in-progress" />
                <StyledTextContainer>
                    <p>{text}</p>
                </StyledTextContainer>
            </StyledInnerContainer>
        </StyledContainer>
    );
};

export default LoaderWithText;
